import type { UserShowData } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { useCommonStore } from '@shared/model'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useUsersStore } from '../model/store'

/**
 * `GET /admin-api/users/{user}` — one user plus the full team list for the edit form's picker.
 */
export const useUserApi = async (userId: string | number): Promise<UserShowData | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useUsersStore()
  const commonStore = useCommonStore()

  const url = useAdminRoutes('admin.user.data', { user_id: userId })

  commonStore.setLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    const showData: UserShowData | null = data.data || null

    if (showData) {
      store.setCurrentUser(showData.user)
      store.setTeams(showData.teams)
    }

    return showData
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    commonStore.setLoading(false)
  }
}
